import { Link } from "@mui/material";
import { type FC, Fragment } from "react";
import { getChatMessageSegments } from "web_myplann/Chat/Helpers/Messages/getChatMessageSegments";

type Props = {
	content: string;
	linkColor: string;
};

export const ChatMessageText: FC<Props> = ({ content, linkColor }) =>
	getChatMessageSegments(content).map(({ start, text, href }) =>
		href ? (
			<Link
				key={start}
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				underline="always"
				color={linkColor}
				sx={{ fontSize: "inherit", textDecorationColor: "currentColor" }}
			>
				{text}
			</Link>
		) : (
			<Fragment key={start}>{text}</Fragment>
		),
	);
